import React, { Component } from 'react';
import cx from 'classnames';
import $ from 'jquery';

class BackToTop extends Component {
    static backtoTopClick() {
        $('body,html').animate({
            scrollTop: 0
        }, 1000);
    }

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.scroll = this.scroll.bind(this);
        this.updateTimer = null;
    }

    componentDidMount() {
        window.addEventListener('resize', this.scroll);
        window.addEventListener('scroll', this.scroll);
    }

    componentWillReceiveProps() {
        this.updateTimer = setTimeout(() => {
            this.scroll();
        }, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.scroll);
        window.removeEventListener('scroll', this.scroll);
        clearTimeout(this.updateTimer);
    }

    scroll() {
        if ($('.container-back-to-top').length > 0) {
            const winTop = $(window).scrollTop();
            const winHeight = $(window).height();
            const docHeight = $(document).height();

            const scrollMoreThanOneWindow = winTop > winHeight;
            const scrollMoreThan90Percent = winTop + winHeight >= docHeight * 0.9;
            const noScrollBar = winHeight === docHeight;

            this.setState({ show: (scrollMoreThanOneWindow || scrollMoreThan90Percent) && !noScrollBar });
        }
    }

    render() {
        const className = cx('container-back-to-top', {
            show: this.state.show
        });
        return (
            <div className={ className } id={ className } onClick={ BackToTop.backtoTopClick }/>
        );
    }
}

export default BackToTop;



// WEBPACK FOOTER //
// ./src/components/BackToTop.jsx